import { jsxs as n, jsx as e, Fragment as f } from "react/jsx-runtime";
import { Button as o } from "@strata/react-buttons";
import { Spinner as r } from "@strata/react-loading-animation";
import "./main.scss";
const u = ({
  formTitle: s = "Default Form Title",
  formHeaderRightContent: a = void 0,
  formLeftContent: c = void 0,
  formRightContent: i = void 0,
  primaryButtonLabel: l = "Save",
  onCancelClick: d = void 0,
  onFormSubmit: m = void 0,
  isSubmitting: _ = !1,
  isLoading: t = !1
}) => /* @__PURE__ */ n("form", { className: "sds_form-container", onSubmit: m, autoComplete: "off", children: [
  /* @__PURE__ */ n("div", { className: "sds_form-container__header", children: [
    /* @__PURE__ */ e("div", { className: "sds_form-container__header__title", children: s }),
    a
  ] }),
  /* @__PURE__ */ e("div", { className: "sds_form-container__content", children: t ? /* @__PURE__ */ e(
    r,
    {
      className: "sds_form-container__content--loading",
      size: r.Size.LARGE
    }
  ) : /* @__PURE__ */ n(f, { children: [
    /* @__PURE__ */ e("div", { className: "sds_form-container__content__column", children: c }),
    i && /* @__PURE__ */ e("div", { className: "sds_form-container__content__column", children: i })
  ] }) }),
  /* @__PURE__ */ n("div", { className: "sds_form-container__footer", children: [
    /* @__PURE__ */ e(o, { intent: o.Intent.NONE, label: "Cancel", onClick: d }),
    /* @__PURE__ */ e(
      o,
      {
        intent: o.Intent.PRIMARY,
        disabled: _ || t,
        type: "submit",
        label: l
      }
    )
  ] })
] });
export {
  u as FormContainer
};
//# sourceMappingURL=index.js.map
